export default __webpack_public_path__ + "static/media/2x2.e43645c9.svg";